export const mockMapeamentos = [
  {
    funilObraGrupoProdutoId: 1,
    dataNegociacao: '2026-06-07',
    unidadeMedidaId: 1,
    volumeMapeado: 5000,
    volumeNegociado: 3000,
    semConsumo: false,
  },
  {
    funilObraGrupoProdutoId: 2,
    dataNegociacao: '2026-06-15',
    unidadeMedidaId: 2,
    volumeMapeado: 2500,
    volumeNegociado: 1800,
    semConsumo: false,
  },
  {
    funilObraGrupoProdutoId: 3,
    dataNegociacao: '2026-06-07',
    unidadeMedidaId: 1,
    volumeMapeado: 5000,
    volumeNegociado: 3000,
    semConsumo: false,
  },
  {
    funilObraGrupoProdutoId: 4,
    dataNegociacao: '2026-06-15',
    unidadeMedidaId: 1,
    volumeMapeado: 2500,
    volumeNegociado: 1800,
    semConsumo: false,
  },
  {
    funilObraGrupoProdutoId: 5,
    dataNegociacao: '2026-06-07',
    unidadeMedidaId: 1,
    volumeMapeado: 5000,
    volumeNegociado: 3000,
    semConsumo: false,
  },
  {
    funilObraGrupoProdutoId: 6,
    dataNegociacao: '2026-06-15',
    unidadeMedidaId: 2,
    volumeMapeado: 2500,
    volumeNegociado: 1800,
    semConsumo: false,
  },
];
